import Vue from 'vue/dist/vue';
import { store } from 'js/modules/vue/store';
import { formatMoney } from 'helpers/utils';

Vue.component('ccrrcard', {
    template: '#ccrr-card-template',
    props: {
        item: Object,
    },
    computed: {
        availability: function () {
            let html = ``;
            switch (this.item.Inventory.Product.Availability) {
                case 100:
                    html =
                        'Yes <i class="ob__overview__icon success fa fa-check" aria-hidden="true"></i>';
                    break;
                case 300:
                    html = `Backordered <i aria-hidden="true" class="ob__overview__icon alert fa fa-exclamation-triangle"></i>`;
                    break;
                case 200:
                    html = `SmartShip <img class="ob__overview__icon" src="/assets/smartship.png">`;
                    break;
                default:
            }
            return html;
        },
        dstyle: function () {
            const bounds = document.querySelector('#order-builder-search').getBoundingClientRect();
            const mobileSize = 120;
            return `max-width: ${
                (bounds.width - 96) / 3 <= mobileSize
                    ? (bounds.width - 64) / 2 <= mobileSize
                        ? mobileSize
                        : (bounds.width - 64) / 2
                    : (bounds.width - 96) / 3
            }px`;
        },
        price: function () {
            return formatMoney(this.item.Inventory.Product.ActualCost);
        },
    },
    methods: {
        updateModal: function () {
            store.commit('UpdateModal', { Data: this.item, Show: true });
        },
    },
});
